// extracted by mini-css-extract-plugin
export var actions = "_s3-4";
export var item = "_s3-1";
export var price = "_s3-3";
export var quantity = "_s3-2";
export var table = "_s3-0";